import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var incomeDetailsVerificationConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: true,
  stepDetailsProps: {
    title: 'STEP 7',
    heading: 'Income details',
    avatarIcon: 'MoneyIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  checkboxProps: {
    label: 'I agree to all terms and conditions.',
    value: 'agree_T&C',
    actionCta: 'View T&C'
  },
  dropdownsDataProps: {
    incomeDropdown: {
      placeholder: 'Select your income',
      label: 'Your income (yearly)',
      postfixIconName: 'DownChevronIcon',
      variant: 'none',
      filterKey: 'subHeading',
      clearSearchOnDropdownListChange: false
    },
    familyIncomeDropdown: {
      placeholder: 'Select total family income',
      label: 'Family income (yearly)',
      postfixIconName: 'DownChevronIcon',
      variant: 'none',
      filterKey: 'subHeading',
      clearSearchOnDropdownListChange: false
    }
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};